import { ChangeDetectionStrategy, ChangeDetectorRef, Component, model, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { isArray } from 'lodash';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { ProductPriceInfoComponent, ProductPriceInfoExt } from '../product-price-info-widget/product-price-info.component';

@Component({
  selector: 'app-formly-product-price-info',
  templateUrl: './formly-product-price-info.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ProductPriceInfoComponent,
    ReactiveFormsModule,
    FormlyModule
  ]
})
export class FormlyProductPriceInfoComponent extends FieldType<FieldTypeConfig> {

  productPriceInfos = model<ProductPriceInfoExt[]>([]);
  doc = model<Document>(null);
  upDownButtons = model<boolean>();

  constructor(
    private i18n: I18nService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {

    if (this.model?.document && !this.doc())
      this.doc.set(this.model?.document);

    else if (this.formState?.detailComponent?.document && !this.doc())
      this.doc.set(this.formState?.detailComponent?.document);

    let needChangeDetection = false;
    if (this.props.options && isArray(this.props.options)) {
      for (let i = 0; i < this.props.options.length; i++) {
        const option = this.props.options[i];
        if (option.translate && option.label) {
          option.label = this.i18n.translate(option.label);
          needChangeDetection = true;
        }
      }
    }
    this.productPriceInfos = this.formState?.detailComponent?.activeProductPriceInfos;
    if (needChangeDetection) {
      this.cdRef.markForCheck();
    }
  }
}
